import { render, staticRenderFns } from "./qa.vue?vue&type=template&id=d119b09e&scoped=true&"
import script from "./qa.vue?vue&type=script&lang=js&"
export * from "./qa.vue?vue&type=script&lang=js&"
import style0 from "./qa.vue?vue&type=style&index=0&id=d119b09e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d119b09e",
  null
  
)

export default component.exports